module.exports = __webpack_public_path__ + "img/logo-white.b7112969.svg";